import { GET_ORDERS_OF_TOTEM } from 'data/queries';

import { ORGANIZATION_FRAGMENT } from 'data/fragments/organization.fragments';

import { cache } from 'data/connection/client.connection';
import { OrderValidatedCacheHandlerParams } from 'types/cache.types';
import { GetOrdersOfTotemQuery } from 'data/__generated__';

export function orderValidatedCacheHandler({
    apolloClient,
    orderId,
    totemId,
    updatedOrder,
    updatedOrganization,
}: OrderValidatedCacheHandlerParams): void {
    /* Update organization */
    apolloClient?.writeFragment({
        _id: cache.identify(updatedOrganization ?? {}) ?? updatedOrganization?._id,
        fragment: ORGANIZATION_FRAGMENT,
        fragmentName: 'OrganizationFragment',
        data: updatedOrganization,
    });

    /* Update order */
    const result = apolloClient.readQuery({
        query: GET_ORDERS_OF_TOTEM,
        variables: { totemId },
    });
    if (!result || !result.ordersOfTotem) return;

    const ordersOfTotem = result?.ordersOfTotem as GetOrdersOfTotemQuery['ordersOfTotem'];
    const recentOrdersRaw = ordersOfTotem?.recentOrders;
    const recentOrders = Array.isArray(recentOrdersRaw) ? recentOrdersRaw : [];
    const updatedOrders = [...recentOrders];
    const orderIds = updatedOrders.map((localOrder) => localOrder?._id);
    const orderIndex = orderIds.indexOf(orderId);
    if (orderIndex === -1) return;

    updatedOrders[orderIndex] = updatedOrder as (typeof updatedOrders)[number];

    apolloClient.writeQuery({
        query: GET_ORDERS_OF_TOTEM,
        variables: { totemId },
        data: { ordersOfTotem: { ...ordersOfTotem, recentOrders: updatedOrders } },
    });
}
